/**
 * Word Compressor - /documents/word page
 */
import { createApp } from 'vue';
import WordCompressor from '@/Components/WordCompressor.vue';
import '@styles/app.css';

createApp(WordCompressor).mount('#word-compressor');
